import { getAccountCapabilities } from '@/features/ctrls-and-caps/get-account-capabilities'
import { getPlayerAccountState } from '@/apis/pam-account-api'
import { FrontendExperience } from '@/features/ctrls-and-caps/frontend-experience'
import { redirect } from '@tanstack/react-router'

/**
 * This function should be used as a guard in the before load route methods.
 *
 * It asserts that player has CanPlay capability and if not it redirects to the locked page
 */
export const assertCanPlayBeforeLoad = async () => {
  const { canPlay } = await getAccountCapabilities()

  if (canPlay) {
    return
  }

  // If Player has `canPlay: false` we need to fetch frontend experiences to understand WHY
  const state = await getPlayerAccountState({})

  if (!state.data?.frontendExperiences.length) {
    // todo: what should we do if there no frontend experience associated?
    return
  }

  const experiences = state.data?.frontendExperiences.map((e) => e.code)

  if (experiences.includes(FrontendExperience.SELF_EXCLUSION)) {
    throw redirect({ to: '/account-locked' })
  }

  if (experiences.includes(FrontendExperience.PLAYER_UNDER_AGE)) {
    throw redirect({ to: '/age-restricted' })
  }

  if (experiences.includes(FrontendExperience.MUST_VERIFY_NOW)) {
    throw redirect({ to: '/verification-required' })
  }
}
